import { memo, type PropsWithChildren } from 'react'

import { Tooltip, TooltipContent, TooltipTrigger, type TooltipContentProps, type TooltipProps } from './Tooltip'

export interface SimpleTooltipProps
  extends
    PropsWithChildren,
    Pick<TooltipContentProps, 'side' | 'align' | 'className' | 'arrowClassName' | 'isArrowVisible'> {
  content: React.ReactNode
  tooltipProps?: Omit<TooltipProps, 'children'>
  asChild?: boolean
  delayDuration?: number
}

export const SimpleTooltip = memo(
  ({
    content,
    children,
    tooltipProps,
    asChild = true,
    side = 'top',
    align,
    isArrowVisible = true,
    delayDuration = 400,
  }: SimpleTooltipProps) => (
    <Tooltip delayDuration={delayDuration} {...tooltipProps}>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
      <TooltipContent side={side} align={align} isArrowVisible={isArrowVisible}>
        {content}
      </TooltipContent>
    </Tooltip>
  ),
)
SimpleTooltip.displayName = 'SimpleTooltip'
